import {
	Box,
} from "@mui/material"
import {useEffect} from "react"
import {useSnackbar} from "notistack"
import AccountSettingsNav from "../components/account_settings/AccountSettingsNav"
import AccountSettingsDrawer from "../components/account_settings/AccountSettingsDrawerMenu"
import Loading from "../components/Loading"
import {useDispatch, useSelector} from "react-redux"
import {
	clearUserCustomerDataError, clearUserCustomerDataSuccess,
	getProductsFromStripe,
	selectCustomerData,
	selectLoadingCustomerData,
	selectSubscriptionData,
	selectUserCustomerDataError, selectUserCustomerDataSuccessMessage,
} from "../reducers/stripeDetailsSlice"
import {selectLoadingUser} from "../reducers/userSlice"
import {
	accountSettingsComponents,
	selectOpenAccountSettingsComponent
} from "../reducers/accountSettingsNavSlice"
export const TOOLBAR_HEIGHT = "2.5em"
export const DRAWER_WIDTH = 200 //px

export default function AccountSettings(){
	const {enqueueSnackbar} = useSnackbar()
	const dispatch = useDispatch()

	const loadingUserData = useSelector(selectLoadingUser)
	const loadingStripeData = useSelector(selectLoadingCustomerData)
	const userSubscriptionData = useSelector(selectSubscriptionData)
	const userCustomerData = useSelector(selectCustomerData)
	const userCustomerDataError = useSelector(selectUserCustomerDataError)
	const userModifyDataSuccess = useSelector(selectUserCustomerDataSuccessMessage)
	const openComponentKey = useSelector(selectOpenAccountSettingsComponent)
	const openComponent = accountSettingsComponents[openComponentKey]

	useEffect(() => {
		if(loadingUserData === false) {
			dispatch(getProductsFromStripe())
		}
	}, [loadingUserData])

	useEffect(() => {
		if(userCustomerDataError !== null){
			enqueueSnackbar(userCustomerDataError, {
				variant: "error",
				autoHideDuration: 3000,
				onClose: () => dispatch(clearUserCustomerDataError()),
			})
		}
	}, [userCustomerDataError])

	useEffect(() => {
		if(userModifyDataSuccess !== null) {
			enqueueSnackbar(userModifyDataSuccess, {
				variant: "success",
				autoHideDuration: 3000,
				onClose: () => dispatch(clearUserCustomerDataSuccess()),
			})
		}
	}, [userModifyDataSuccess])

	return loadingUserData
		? ( <Loading /> )
		: (
			<Box>
				<AccountSettingsNav
					title={"Account Settings"}
					toolbarHeight={TOOLBAR_HEIGHT}
				/>
				<Box sx={{display: "flex"}}>
					<AccountSettingsDrawer
						toolbarHeight={TOOLBAR_HEIGHT}
						drawerWidth={DRAWER_WIDTH}
					/>
					<Box
						sx={{
							width:"100%",
							height: "100%",
							padding: `calc(${TOOLBAR_HEIGHT} + 20px) 2.5rem 2.5rem 2.5rem`,
							maxHeight: "100vh",
							overflowY: "scroll",
						}}
					>
						{
							(loadingStripeData || userSubscriptionData === null) ? <Loading /> :
								(<openComponent.component
									userSubscription={userSubscriptionData}
									userCustomer={userCustomerData}
									enqueueSnackbar={enqueueSnackbar}
								/>)
						}
					</Box>
				</Box>
			</Box>
		)
}